import { GenericChip } from './GenericChip';
import { GENERIC_CHIP_COLOR } from '@shared/types/enums';

export const SyncingChip = () => {
  return <GenericChip label="Syncing" color={GENERIC_CHIP_COLOR.LightPink} />;
};
